module.exports = __webpack_public_path__ + "static/media/cal-pill.42719fe1.jpg";